
import BasePropertyView from 'BasePropertyView.js';
import eventBus from 'EventBus';
import util from 'util/Util.js';
import constants from 'Constants.js';
import listService          from 'ListService.js';

class BaseTableView extends BasePropertyView  {

        initialize(opts){
            this.opts = opts; 
            this.scrollToRowId = 0;
        }

        get gridEl() { return this._gridEl; }
        set gridEl( el )  { this._gridEl = el; }

        updateAttributes(ev) {
            ev.preventDefault();
            const propName = ev.currentTarget.name;
            const propVal  = ev.currentTarget.value;
            this.model.set( propName, propVal );
            util.saveGridScrollPos(this.model);
        }

        getFocus(ev) {
            $(ev.currentTarget).addClass('pfSelectedBlue');
        }

        lostFocus(ev) {
            $(ev.currentTarget).removeClass('pfSelectedBlue');
        }

        itemRemove(){
            util.saveGridScrollPos(this.model);
            if (listService.selectedCount > 1) {
                let that = this;
                listService.selected.map((view, key)=>{
                    this.model = view.model;
                    var gridData = this.model.get('gridData');
                    var rowid = this.model.get('rowid');
                    const deleteIndex = rowid === undefined ? gridData.length -1: rowid;
                    
                    this.model.set( gridData.splice(deleteIndex, 1), constants.MODEL_SILENT );
                    this.model.set({ rowid: undefined }, constants.MODEL_SILENT);
                });
                this.scrollToRowId = this.model.get('gridData').length-1;
                that.render();
            } else {
                var gridData = this.model.get('gridData');
                var rowid = this.model.get('rowid');
                const deleteIndex = rowid === undefined ? gridData.length -1: rowid;
                
                this.model.set( gridData.splice(deleteIndex, 1) );
                this.model.set({ rowid: undefined }, {silent: true});
                this.scrollToRowId = this.model.get('gridData').length-1;
                this.render();
            }
        } 

        itemUp() {
            util.saveGridScrollPos(this.model);
            var gridData = this.model.get('gridData');
            var rowId = parseInt(this.model.get('rowid'));
            var newRowId = rowId - 1;

            if (rowId > 0) {
                gridData[rowId] = gridData.splice((newRowId), 1, gridData[rowId])[0];
                this.model.set('rowid', newRowId);
                this.model.set('gridData', gridData);
                this.render();
            }
        }


        itemDown() {
            util.saveGridScrollPos(this.model);
            var gridData = this.model.get('gridData');
            var rowId = parseInt(this.model.get('rowid'));
            var newRowId = rowId + 1;

            if (rowId < (gridData.length - 1)) {
                gridData[rowId] = gridData.splice(newRowId, 1, gridData[rowId])[0];
                this.model.set('rowid', newRowId);
                this.model.set('gridData', gridData);
                // console.log(gridData);
                this.render();
            }
        }     


        itemCheck(e){
            util.saveGridScrollPos(this.model);
            // console.log('itemCheck');
            var i = $(e.currentTarget).closest('tr').index()-1;
            var gridData = this.model.get('gridData');

            gridData.forEach(function(value, index) {
                gridData[index].selected = '';
            });// reset out all

            if( e.currentTarget.checked ){
                gridData[i].selected = 'selected';
            } else {
                // Index should be -1 if nothing is selected
                i = "-1";
            }

            this.model.set('gridData', gridData, {silent: true});
            this.model.set('selectedIndex', i, { silent: true });
  
            this.model.trigger('change');
            this.render();
        }

        saveCell(rowid, cellname, value){
            // console.log('afterSaveCell ' + rowid);
            // console.log(cellname);
            this.model.unset('newRowAdded', constants.MODEL_SILENT);
            util.saveGridScrollPos(this.model);
            if (listService.selectedCount > 1) {
                listService.selected.map(view=>{
                    this.model = view.model;
                    var gridData = this.model.get('gridData');   
                    const oldVal = gridData[rowid][cellname];                    
                    gridData[rowid][cellname] = util.sanitizeHTML(value, true, oldVal);
                    this.model.set('gridData', gridData, {silent: true});
                    this.model.trigger('change');
                    this.render();
                });
            } else {
                var gridData = this.model.get('gridData');  
                const oldVal = gridData[rowid][cellname];                                 
                gridData[rowid][cellname] = util.sanitizeHTML(value, true, oldVal);
                this.model.set('gridData', gridData, {silent: true});
                this.model.trigger('change');
                this.render();
            }
            eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);
        }

        setRow(rowid){
            this.model.set({
                rowid: rowid
            }, {silent: true});
        }
        
        onCellSelect(rowid, iCol, cellcontent,e){
            return;
        }

        onSelectRow(rowId, status,e){
            return;
        }

        afterEditCell(rowId, cellName, value, iRow, iCol) {
            let $control = $("#" + iRow + "_" + cellName);
            if ($control.length > 0) {
                $control[0].select();
            }
            util.setGridScrollPos(this.model);
            return;
        }

        // Method that renders an scroll in the grid in order to navigate the same on small screens.
        resizeGrid() {
            /*let grid = $(this.el).find('.ui-jqgrid-btable');
            if (grid.length) {
                grid.each(function(index) {
                    let gridId = $(this).attr('id');
                    //  If there is no width on parent yet, set a minimum width of 300px
                    let gridParentWidth = $('#gbox_' + gridId).parent().width()? $('#gbox_' + gridId).parent().width() : 300;
                    $('#' + gridId).setGridWidth(gridParentWidth);
                });
            }*/
            util.resizeGridWidth();
        }

        onRender(){
            return;
        }

        afterRender(){
            // PF-4154: Scrolling to specific row
            util.setGridScrollPos(this.model);
        }

        onLoadComplete(){
            return;
        }

        getColumnIndexByName(columnName) {
            var cm = $(this._gridEl).jqGrid('getGridParam', 'colModel');
            for (var i = 0, l = cm.length; i < l; i++) {
                if (cm[i].name === columnName) {
                    return i;
                }
            }
            return -1;
        }

        render() {
            if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
                this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
            }

            this.onRender();
            var gridData = this.model.get('gridData') === '' ? [] : this.model.get('gridData');

            this.$el.empty();
            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }

            const self = this;
            const height = (this.model.get('factoryKey') === 'command_notify' ) ? 90 : 110;
            
            $(self._gridEl).jqGrid({
                datatype: "local",
                autoencode: true,
                autowidth: true, 
                shrinkToFit: true,
                altRows: true,
                cellEdit: true,
                height: height,
                cellsubmit : 'clientArray',
                onCellSelect: function(rowid, iCol, cellcontent,e){
                    self.onCellSelect(rowid, iCol, cellcontent,e);
                    util.saveGridScrollPos(this.model);
                },
                onSelectRow: function(rowId, status,e){
                    self.onSelectRow(rowId, status,e);
                },
                gridComplete: function() {
                    $(self._gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");

                }, 
                //jsonReader : {root: this.model.get('rows') },
                colNames: self.model.get('colNames'),
                colModel: self.model.get('colModel'),
                beforeSelectRow: function (rowid,e) {
                    self.setRow(rowid,e);
                },
                afterSaveCell: function (rowid, cellname, value) {
                    self.saveCell(rowid, cellname, value);
                },
                afterEditCell: function (rowId, cellName, value, iRow, iCol) {
                    self.afterEditCell(rowId, cellName, value, iRow, iCol);
                },
                onDblClickRow:function(rowid,iRow,iCol,e){
                    self.onDblClickRow(rowid,iRow,iCol,e)
                },
                onSortCol:function (index, iCol,sortorder) {
                    let onSort=self.model.get('onSortCol');
                    if (onSort) {
                        onSort(index, iCol,sortorder);
                    }                    
                }, 
                resizeStop: function(width, index) {
                    let columns = $(self._gridEl).jqGrid ('getGridParam', 'colModel');
                    let colWidth = columns.filter(c => !c.hidden).reduce((a, c) => a + c.width, 0);

                    if ($("#gbox_propMainTable").width() < colWidth) {
                        $(self._gridEl).closest('.ui-jqgrid-bdiv')
                            .css('overflow', '')
                            .addClass('format-table-overflow-shown');
                    }
                }
            });

            $(self._gridEl).jqGrid("clearGridData");
            gridData.forEach(function(value, index) {
                $(self._gridEl).addRowData(index, value);
            });

            self.onLoadComplete();

            if (this.config) {
                if (this.config.showTitle) {
                    this.$el.find('.propTitle').removeClass('hide');
                }
            }

            let containsConnect = _.includes(["command_connect_search", "command_connect"], this.model.get('factoryKey'));
            this.resizeGrid();
           
            this.delegateEvents();  
            
            this.afterRender();
            eventBus.trigger(constants.RESIZE_PROPERTIES_STYLE_PANEL, this.model.get('factoryKey'));
            return this;
        }
    }

export default BaseTableView;
